"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

export default function ErrorPage() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");

  const errorMessages: { [key: string]: string } = {
    Signin: "Try signing in with a different account.",
    OAuthSignin: "Try signing in with a different account.",
    OAuthCallback: "Try signing in with a different account.",
    OAuthCreateAccount: "Try signing in with a different account.",
    EmailCreateAccount: "Try signing in with a different account.",
    Callback: "Try signing in with a different account.",
    OAuthAccountNotLinked: "Email already in use with another provider.",
    EmailSignin: "Check your email address.",
    CredentialsSignin: "Sign in failed. Check your credentials.",
    SessionRequired: "Please sign in to access this page.",
    default: error ?? "An error occurred. Please try again.",
  };

  const errorMessage = error
    ? (errorMessages[error] ?? errorMessages.default)
    : errorMessages.default;

  return (
    <div className="container flex h-[calc(100vh-4rem)] flex-col items-center justify-center gap-4">
      <div className="space-y-2 text-center">
        <h1 className="font-heading text-4xl font-semibold">
          Authentication Error
        </h1>
        <p className="text-lg text-muted-foreground">{errorMessage}</p>
      </div>

      <Link href="/sign-in">
        <Button size="lg" className="mt-4">
          Back to Sign In
        </Button>
      </Link>
    </div>
  );
}
